/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { Radio } from '@insticator/insticator-ui'
// content
import PreviewConfig from '../../previewconfig/previewconfig'
// styles
import injectSheet from 'react-jss'
import styles from './userstatusbadges_styles'
import UserBadge from '../components/userbadge/userbadge';
import { isLight } from 'utils/theme'

const badges = ['RECRUIT', 'RISING_STAR', 'CONVERSATION_STARTER', 'TOP_COMMENTER', 'TRAILBLAZER', 'VIP', 'LEGEND', 'HALL_OF_FAMER']
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : USER STATUS BADGES ~~~~~~~~~~ ========== */
const UserStatusBadges = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig, themeColors } = props

  const handleBadgeStyleChange = style => setSiteThemeConfig('userBadgeStyle', style)
  
  return (
    <SectionGroupV2 
      title={'Status Badges'} 
      description={'Mute or colorize user status badges to fit your sites visual theme.'}
      indented
      direction={'column'}
    >
      <Space direction={'column'}>
        <span>Style</span>
        <Radio 
          isList
          title={`Colorful`}
          checked={siteTheme.userBadgeStyle === 'COLORFUL'}
          handleChange={() => handleBadgeStyleChange('COLORFUL')}
        />
        <Radio 
          isList
          title={`Monochrome`}
          checked={siteTheme.userBadgeStyle === 'MONOCHROME'}
          handleChange={() => handleBadgeStyleChange('MONOCHROME')}
        />
      </Space>
     <PreviewConfig>
      <Space flexWrap={true} gap={10}>
        {badges.map(badge => (
          <UserBadge 
          themeColors={themeColors} 
          language={siteTheme.language}
          isDark={!isLight(siteTheme.customBackgroundColor)}
          extension={siteTheme.themeExtension} 
          name={badge} 
          style={siteTheme.userBadgeStyle} 
          backgroundColor={themeColors.backgroundSecondary} 
          />
        ))}
      </Space>
    </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default UserStatusBadges